(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.SizeGuideRouting = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function classifySku(sku) {
    const match = String(sku || '').trim().toUpperCase().match(/^FN(\d{4})/);

    if (!match) {
      return null;
    }

    const number = Number(match[1]);

    if (number === 0) {
      return null;
    }

    return number <= 2629 ? 'old' : 'new';
  }

  function isStyleFn25422212(sku) {
    // 款号精确为 FN25422212；变体 SKU 允许后缀（颜色/尺码等）
    return String(sku || '').trim().toUpperCase().startsWith('FN25422212');
  }

  function resolveTableKey(sku, hasMultipleSets, fit) {
    const era = classifySku(sku);
    const normalizedFit = String(fit || '').trim().toLowerCase();

    if (!era) {
      return null;
    }

    if (!hasMultipleSets) {
      return `${era}-regular-1`;
    }

    if (isStyleFn25422212(sku)) {
      if (normalizedFit === 'regular') {
        return 'old-regular-1';
      }

      if (normalizedFit === 'petite') {
        return 'old-petite';
      }

      return null;
    }

    if (normalizedFit === 'regular') {
      return `${era}-regular-2`;
    }

    if (normalizedFit === 'petite') {
      // 旧款双身高：Petite → 旧-常规；新款仍用新-p
      return era === 'old' ? 'old-regular-1' : 'new-petite';
    }

    return null;
  }

  return {
    classifySku,
    resolveTableKey,
  };
});
